import { useRouter } from 'next/router'
import React, { useContext, useState } from 'react'

import {
  buildActionAnalyticsAttributes,
  getClient,
} from '@mondough/analytics-v2'
import { Copy, useCopy } from '@mondough/copy'
import { ButtonGroup, Text, Title } from '@mondough/monzo-ui'

import { TabContext } from '../../providers/TabProvider'
import styles from './LeaveTabDialog.module.scss'
import { Button, Dialog } from '..'

const LeaveTabDialog = ({
  setShowDialog,
  onLeave,
}: {
  setShowDialog: React.Dispatch<React.SetStateAction<boolean>>
  onLeave: () => void
}) => {
  const c = useCopy()
  const router = useRouter()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const { refreshTab } = useContext(TabContext)

  return (
    <Dialog
      id="leave-tab-dialog"
      onDismiss={() => {
        setShowDialog(false)
        setError(null)
        const analyticsClient = getClient()
        if (!analyticsClient) return
        analyticsClient.trackAction({
          name: 'dismiss',
          type: 'click',
        })
      }}
      className={styles['leave-tab-dialog']}
    >
      <Title align="center" marginBottom="small">
        <Copy.Simple
          id="app_tabs_monzo_me.leave.dialog.title"
          fallback="Are you sure you want to leave this Split?"
        />
      </Title>
      <Text marginBottom="extra-small">
        <Copy.Simple
          id="app_tabs_monzo_me.leave.dialog.subtitle"
          fallback="You can only rejoin with a valid invite link."
        />
      </Text>
      {error && (
        <Text color="destructive" marginBottom="small" className={styles.error}>
          {error}
        </Text>
      )}
      <ButtonGroup direction="vertical" className={styles['button-group']}>
        <Button
          theme="secondary"
          fullWidth
          onClick={() => {
            setShowDialog(false)
            setError(null)
          }}
          {...buildActionAnalyticsAttributes('back')}
        >
          <Copy.Simple
            id="app_tabs_monzo_me.common.navigation.go_back"
            fallback="Go back"
          />
        </Button>
        <Button
          fullWidth
          id="leave-tab-confirm"
          theme="destructive"
          onClick={async () => {
            try {
              setLoading(true)
              await onLeave()
              setLoading(false)
              await refreshTab()
              setShowDialog(false)
              await router.push('/')
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
            } catch (error) {
              setLoading(false)
              setError(
                c.string({
                  key: 'app_tabs_monzo_me.common.error.generic_message',
                  message: 'Something went wrong. Please try again.',
                }),
              )
            }
          }}
          loading={loading}
          {...buildActionAnalyticsAttributes('leave')}
        >
          <Copy.Simple
            id="app_tabs_monzo_me.common.actions.leave_split"
            fallback="Leave Split"
          />
        </Button>{' '}
      </ButtonGroup>
    </Dialog>
  )
}

export default LeaveTabDialog
